import {
  ComponentConfig,
  LayoutTypes,
  ComponentType,
  FlexDirection,
  ActionType,
} from "../services/types/ComponentTypes";

export const screen_194_vendor_bill_wise_release: ComponentConfig[] = [
  {
    componentType: LayoutTypes.SCREEN_GROUP,
    fabAction: {
      type: "add",
      screenId: "195",
      action: "navigate_modulev1/vendor_bill_wise_release",
    },
    title: "Bill Release",
    style: {
      backgroundColor: "#F9FAFB",
    },
    childComponents: [
      {
        componentType: LayoutTypes.GROUP,
        style: {
          backgroundColor: "#ffffff",
          direction: FlexDirection.COLUMN,
          borderRadius: 12,
          padding: 16,
        },
        childComponents: [
          {
            componentType: ComponentType.SUMMARY_LIST,
            titleValue: "document_no",
            Name: "bill_release_documents_vendor",
            BindValue: "grid_bill_release_documents_vendor",
            SummeryActions: [

            ],
            Form: {
              Name: "bill_release_documents_vendor",
              TableName: "",
              View: "view_bill_release_documents_vendor",
              DisplayName: "bill_release_documents_vendor",
              Fields: [
                {
                  IncludeLabel: true,
                  Label: "id",
                  BindValue: "id",
                  Json_Attribute: "id",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: false,
                  IsPrimary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Party id",
                  BindValue: "party_id",
                  Json_Attribute: "party_id",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: false,
                },
                {
                  IncludeLabel: true,
                  Label: "Document No.",
                  BindValue: "document_no",
                  Json_Attribute: "document_no",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Date",
                  BindValue: "document_date",
                  Json_Attribute: "document_date",
                  componentType: ComponentType.DATE_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Party name",
                  BindValue: "party_name",
                  Json_Attribute: "party_name",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Type",
                  BindValue: "document_type",
                  Json_Attribute: "document_type",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Amount",
                  BindValue: "amount",
                  Json_Attribute: "amount",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                  valueFormat: "currency",
                },
                {
                  IncludeLabel: true,
                  Label: "Settled",
                  BindValue: "settled_amount",
                  Json_Attribute: "settled_amount",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                  valueFormat: "currency",
                },
                {
                  IncludeLabel: true,
                  Label: "Outstanding",
                  BindValue: "outstanding_amount",
                  Json_Attribute: "outstanding_amount",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                  valueFormat: "currency",
                },
                {
                  IncludeLabel: true,
                  Label: "Status",
                  BindValue: "status",
                  Json_Attribute: "status",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
              ],
            },
          },
        ],
      },
    ],
  },
];
